export const colorBack = () => {

  return "#163149";
};

export const colorPrimary = () => {

  return "#163149";
};

export const colorIconesMenu = () => {

  return "#163149";
};

export const colorTitleTable = () => {

  return "#e5e5e5";
};

export const colorTopTable = () => {

  return "#ededed";
};

export const colorBackgroundTable = () => {

  return "#2a273b";
};

export const colorLineTable = () => {

  return "#163149";
};

export const colorLineTableHover = () => {

  return "#31506B";
};

export const colorTopbar = () => {

  return "#141414";
};

